export default "__VITE_ASSET__CUQ0SdW4__"